import Tool, { type ToolArgs } from './Tool';
import { ReactEditor } from 'slate-react';
import { Editor, Element, Path, Transforms } from 'slate';
import EditorUtils from '../AhaEditorUtils/EditorUtils';

// Insert an empty paragraph below the current element.
class ToolInsertSpaceBelow extends Tool {
  static toolName = 'Insert space below';
  static iconClass = 'fa-regular fa-down-to-dotted-line';

  static action({ editor, element }: ToolArgs): void {
    if (!editor?.selection) return;

    let path;

    if (element) {
      path = ReactEditor.findPath(editor, element);
    } else {
      // Find the block element at current selection
      const entry = Editor.above(editor, {
        at: editor.selection,
        match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
        mode: 'highest',
      });
      path = entry && entry[1];
    }

    if (!path) return;

    const insertPath = Path.next(path);

    Transforms.insertNodes(editor, EditorUtils.emptyParagraph(), {
      at: insertPath,
    });

    Transforms.select(editor, insertPath);
  }
}

export default ToolInsertSpaceBelow;
